import { animate, style, transition, trigger } from '@angular/animations';
import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

export interface IUpdateAvailableDialogData {
  version: string;
}

@Component({
  selector: 'app-update-available-dialog',
  templateUrl: './update-available-dialog.component.html',
  styleUrls: ['./update-available-dialog.component.scss'],
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, MatIconModule, TranslateModule],
  animations: [
    trigger('dialogScale', [
      transition(':enter', [
        style({ transform: 'translateY(16px)', opacity: 0 }),
        animate('250ms cubic-bezier(0.4, 0, 0.2, 1)', style({ transform: 'translateY(0)', opacity: 1 })),
      ]),
      transition(':leave', [
        animate('200ms cubic-bezier(0.4, 0, 1, 1)', style({ transform: 'translateY(-12px)', opacity: 0 })),
      ]),
    ]),
  ],
  host: {
    '[@dialogScale]': 'true',
  },
})
export class UpdateAvailableDialogComponent {
  constructor(
    private readonly dialogRef: MatDialogRef<UpdateAvailableDialogComponent, 'reload'>,
    @Inject(MAT_DIALOG_DATA) public readonly data: IUpdateAvailableDialogData,
  ) {}

  public reload(): void {
    this.dialogRef.close('reload');
  }
}
